/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiUniversalDocumentEntityType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    MONITORING_ALERT = 'MONITORING_ALERT',
    SCREENING_ALERT = 'SCREENING_ALERT',
    BRIDGE_ALERT = 'BRIDGE_ALERT',
    MANUAL_ALERT = 'MANUAL_ALERT',
    ALERT_FILTER = 'ALERT_FILTER',
    ENTITY_SEARCH_FILTER = 'ENTITY_SEARCH_FILTER',
    CASE = 'CASE'
}


export function instanceOfInternalApiUniversalDocumentEntityType(value: any): boolean {
    for (const key in InternalApiUniversalDocumentEntityType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiUniversalDocumentEntityType, key)) {
            if (InternalApiUniversalDocumentEntityType[key as keyof typeof InternalApiUniversalDocumentEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiUniversalDocumentEntityTypeFromJSON(json: any): InternalApiUniversalDocumentEntityType {
    return InternalApiUniversalDocumentEntityTypeFromJSONTyped(json, false);
}

export function InternalApiUniversalDocumentEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUniversalDocumentEntityType {
    return json as InternalApiUniversalDocumentEntityType;
}

export function InternalApiUniversalDocumentEntityTypeToJSON(value?: InternalApiUniversalDocumentEntityType | null): any {
    return value as any;
}

export function InternalApiUniversalDocumentEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiUniversalDocumentEntityType {
    return value as InternalApiUniversalDocumentEntityType;
}

